// Phase 12 — Travel route.
import * as React from 'react'; import { useQuery } from '@tanstack/react-query';
import { Card, CardContent } from '../../components/ui/Card.js';
import { SkeletonRow } from '../../components/ui/Skeleton.js';
import { EmptyState } from '../../components/ui/EmptyState.js';
import { Button } from '../../components/ui/Button.js';

const STATUS_COLORS: Record<string,string> = { upcoming: 'bg-accent-subtle text-accent-default', active: 'bg-state-success text-text-on-accent', completed: 'bg-surface-raised text-text-secondary border-border-default' };
const STATUS_LABELS: Record<string,string> = { upcoming: 'Upcoming', active: 'Active', completed: 'Done' };

export function Travel(): JSX.Element {
  React.useEffect(() => { document.title = 'DailyDeck — Travel'; }, []);
  const q = useQuery({ queryKey: ['travel','trips'], queryFn: async () => { const r = await fetch('/api/modules/travel/trips',{credentials:'same-origin'}); if(!r.ok) throw new Error('fail'); return r.json(); }, staleTime: 30_000 });

  return (
    <div className="space-y-6" data-testid="travel-route">
      <header><h1 className="text-title-1 font-semibold text-text-primary">Travel</h1><p className="text-body text-text-secondary mt-1">Trip planning with packing lists.</p></header>
      {q.isPending && <div className="rounded-lg border border-border-subtle bg-surface-raised"><SkeletonRow/><SkeletonRow/></div>}
      {q.isError && <Card><CardContent className="py-4"><p className="text-body-strong text-text-primary">Could not load trips</p><Button variant="secondary" className="mt-3" onClick={()=>void q.refetch()}>Retry</Button></CardContent></Card>}
      {q.isSuccess && q.data.length===0 && <EmptyState title="No trips planned" description="Add a trip to start planning." />}
      {q.isSuccess && q.data.length>0 && (
        <div className="space-y-4">
          {q.data.map((t: any) => (
            <Card key={t.id}><CardContent className="py-4 space-y-3">
              <div className="flex items-start justify-between gap-4">
                <div><h3 className="text-body-strong font-medium text-text-primary">{t.title}</h3>
                {t.destination && <p className="text-caption text-text-secondary">{t.destination}</p>}
                {t.start_date && <p className="text-micro text-text-muted mt-1">{t.start_date}{t.end_date?' — '+t.end_date:''}</p>}</div>
                <span className={`inline-flex rounded-full px-2 py-0.5 text-micro font-medium border ${STATUS_COLORS[t.status]??''}`}>{STATUS_LABELS[t.status]??t.status}</span>
              </div>
              {t.items && t.items.length>0 && (
                <div className="space-y-1 pt-2 border-t border-border-subtle">
                  {t.items.map((i: any) => (
                    <div key={i.id} className="flex items-center gap-2 text-caption">
                      <span className={i.packed?'text-state-success':'text-text-muted'}>{i.packed?'✓':'○'}</span>
                      <span className={i.packed?'text-text-muted line-through':'text-text-secondary'}>{i.title}</span>
                      <span className="text-text-muted ml-auto text-micro">{i.category}</span>
                    </div>
                  ))}
                </div>
              )}
            </CardContent></Card>
          ))}
        </div>
      )}
    </div>
  );
}
